export default __webpack_public_path__ + "static/banner-media-release-dec4-applepay-a05411f70dc7ef9327b6fff04074c064.jpg";